import { useEffect } from "react";
import { useStore } from "zustand";
import { WatchAllClientsUseCase } from "@useCases/index";
import { Filter } from "@domain/models/Filters";
import { Paging } from "@domain/models/Paging";
import { FirebaseClientRepository } from "@data/repositories/index";
import userStore from "@data/stores/user";
import clientsStore from "@data/stores/client";

type Props = {
  filters: Filter[];
  paging: Paging;
};

export default function useAllClients({ filters, paging }: Props) {
  const { allClients, allClientsTotal } = useStore(clientsStore);

  const getAllClients = async () => {
    const useCase = new WatchAllClientsUseCase(
      userStore.getState(),
      new FirebaseClientRepository(clientsStore.getState())
    );

    useCase.execute(paging);
  };

  useEffect(() => {
    if (allClients.length === 0) {
      getAllClients();
    }
  }, []);

  useEffect(() => {
    if (filters.length === 0) {
      getAllClients();
    }
  }, [paging]);

  return {
    allClients: allClients.slice(paging.offset, paging.offset + 25),
    allClientsTotal: allClientsTotal,
  };
}
